import { useContext } from "react";
import StudentClassContext from "src/context/studentClassContext";

const useStudentClass = () => {
  const value = useContext(StudentClassContext);
  return value;
};

export default useStudentClass;
